window.HealthyEatingConstants = ({
    httpStatusCode: {
        ok: 200,
        created: 201,
        loginTimeout: 440
    },
    gtm: {
        event: {
            accountError: 'accountError',
            bank: 'bankDetails',
            cancelReview: 'cancelReviewYourDetails',
            complete: 'complete',
            confirmation: 'confirmation',
            continue: 'formContinue',
            cancel: 'formCancel',
            delink: 'delink',
            delinkAcc: 'delinkAccount',
            detailsModal: 'yourDetailsModal',
            editDetails: 'editDetails',
            error: 'error',
            failure: 'failure',
            incorrect: 'incorrectNumber',
            long: 'numberTooLong',
            loyaltyCard: 'myWaitrose',
            noCard: 'noMemberCard',
            partnerName: 'waitrose',
            review: 'reviewYourDetails',
            short: 'numberTooShort',
            successful: 'successful',
            surname: 'surname',
            techError: 'technicalError',
            termsAndData: 'termsAndDataShare',
            validate: 'formValidation',
            waitroseId: 'waitroseId',
            waitroseModal: 'myWaitroseModal'
        },
        action: {
            update: 'update',
            checkDetails: 'checkDetails'
        }
    },
    elements: {
        sessionStorage: {
            membershipNo: 'mn',
            currentStep: 'currentStep'
        },
        constants: {
            maxPage: '4',
            sectionZeroTitle: 'Sign Up',
            sectionOneTitle: 'Bank Details',
            sectionTwoTitle: 'Review Your Details',
            sectionThreeTitle: 'Confirmation',
            sectionFourTitle: 'Complete',
            membershipNoTag: '{membership_no}'
        },
        forms: {
            sectionOne: '#healthy-eating-form-section-one',
            sectionTwo: '#healthy-eating-form-section-two',
            sectionThree: '#healthy-eating-form-section-three',
            sectionFour: '#healthy-eating-form-section-four'
        },
        steps: {
            sectionOne: '#healthy-eating-signup-section-1',
            sectionTwo: '#healthy-eating-signup-section-2',
            sectionThree: '#healthy-eating-signup-section-3',
            sectionFour: '#healthy-eating-signup-section-4',
            failureSection: '#healthy-eating-signup-section-failure'
        },
        progressBarIds: {
            progressBar: '#waitrose-progress-bar',
            progressTitle: '#progress-primary-title',
            progressText: '#progress-text',
            progressBack: '#progress-back',
            progressNext: '#progress-next'
        },
        buttons: {
            delinkButton: '#delink-prompt',
            delinkConfirm: '#delink-confirm',
            detailsCancel: '#details-cancel',
            detailsConfirm: '#details-confirm',
            editBankDetailsCTA: '#edit-bank-details',
            editMembershipNoCTA: '#edit-membership-no',
            editSurnameCTA: '#edit-surname',
            failurePageReload: '#failure-page-reload',
            modalCancel: '#modal-cancel-btn',
            modalConfirm: '#modal-confirm-btn',
            reviewMembershipNoUpdate: '#review-membership-no-update',
            signUpButton: '#sign-up-button',
            stepOneNext: '#step-one-next',
            stepThreeBack: '#step-three-back',
            stepThreeNext: '#step-three-next',
            stepTwoBack: '#step-two-back',
            stepTwoNext: '#step-two-next',
            waitroseCancel: '#waitrose-member-cancel',
            waitroseConfirm: '#waitrose-member-confirm'
        },
        ids: {
            bankCheckbox: '#bank-consent-checkbox',
            bankCheckboxPrompt: '#bank-checkbox-prompt',
            dataShareCheckbox: '#data-sharing-confirm',
            dataSharePrompt: '#data-share-checkbox-prompt',
            delinkFailedErrorNotification: '#account-unlink-failed',
            delinkModal: 'delink-modal',
            errorPage: '#error-page',
            formParent: '#form-parent',
            memberCheckboxId: '#membership-checkbox',
            memberCheckboxPrompt: '#membership-checkbox-prompt',
            membershipNo: '#myWaitrose-membership-number',
            reviewCheckBoxYes: '#statements-are-correct',
            reviewConfirmationWarningMessage: '#confirm-details-warning',
            reviewMembershipNo: '#review-membership-no',
            reviewMembershipNoInput: '#waitrose-number',
            reviewMembershipNoListItem: '#review-membership-no-list-item',
            signupFailureDescription: '#signup-failure-description',
            signupFailureTitle: '#signup-failure-title',
            termsPrompt: '#tandc-checkbox-prompt',
            termsCheckbox: '#terms-conditions-confirm',
            waitroseSurnameModal: '#waitrose-surname-modal',
            closeSurnameModalBtn: '#close-surname-modal-btn'
        },
        classes: {
            inputBoxInvalid: 'vds-form__input--invalid',
            formParentLuhnCheckFail: '.formParent-luhn-check-fail',
            formParentNumberTooLong: '.formParent-number-too-long',
            formParentNumberTooShort: '.formParent-number-too-short',
            buttonEnabled: 'vds-form-journey__button',
            buttonDisabled: 'vds-button--disabled',
            validation: {
                luhnCheckFail: '.luhn-check-fail',
                tooShort: '.number-too-short',
                tooLong: '.number-too-long'
            },
            membershipNo: '.membership-number',
            listItemEditState: 'vds-checklist__list-item--edit-state',
            itemRemoved: 'vds-item-removed'
        },
        input: {
            yesCard: '#yesCard',
            noCard: '#noCard'
        }
    }
});
